import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

// SoccerBible signs its newsletter with a name. So does ours.
export const NewsletterBrief = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data?.message || "You're on the list.");
      setEmail("");
    } catch {
      toast.error("That didn't send. Try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="border-t border-zinc-900 bg-black py-16 md:py-20" data-testid="home-newsletter-brief">
      <div className="mx-auto grid max-w-[1500px] gap-10 px-5 md:grid-cols-[minmax(0,1fr)_minmax(0,420px)] md:items-end md:px-10">
        <div>
          <p className="eyebrow">The brief</p>
          <h2 className="display-2 mt-4 max-w-2xl">The Kick Start Brief</h2>
          <p className="body-copy mt-6 max-w-xl">
            One email when something real happens: a county costed, a facility modelled, a player added to the
            archive, a recommended step reached. No fixture gossip, no transfer rumours, and nothing sold on.
          </p>
        </div>
        <form onSubmit={subscribe} className="flex flex-col gap-3 sm:flex-row" data-testid="brief-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            data-testid="brief-email-input"
            className="min-w-0 flex-1 border border-white/20 bg-transparent px-4 py-3 text-sm text-white placeholder:text-zinc-400 focus:border-ochre focus:outline-none"
          />
          <button
            type="submit"
            disabled={busy}
            className="btn-primary justify-center disabled:opacity-60"
            data-testid="brief-submit"
          >
            {busy ? "Sending" : "Sign up"}
          </button>
        </form>
        <p className="mt-4 max-w-xl text-xs leading-relaxed text-zinc-500 sm:col-span-2" data-testid="brief-consent">
          By signing up you agree to receive the brief by email. Unsubscribe from any email. We never sell or
          share your address.{" "}
          <Link to="/privacy" className="text-ochre underline">How we use your data</Link>.
        </p>
      </div>
    </section>
  );
};
